export * from "./PatientsTable";
export * from "./PatientDetails";
export * from "./UpdatePatient";
export * from "./MedicalCard";
export * from "./UploadPhotoForm";
export * from "./MedicalCardsHistory";
